import { IconButton, Badge } from "@material-ui/core";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import React from "react";

interface BeachSelectorControls {
  isReserved: boolean;
  seatBookedNum?: number;
  setSelectedSeat: () => void;
}

const BeachSelectorControls: React.FC<BeachSelectorControls> = ({
  isReserved,
  setSelectedSeat,
  seatBookedNum,
}) => {
  return (
    <div>
      <div>
        <IconButton
          onClick={setSelectedSeat}
          aria-label="delete"
          color={isReserved ? "primary" : "default"}
        >
          <Badge badgeContent={seatBookedNum} color="secondary">
            <BeachAccessIcon></BeachAccessIcon>
          </Badge>
        </IconButton>
      </div>
    </div>
  );
};

export default BeachSelectorControls;
